export default __webpack_public_path__ + "static/EDUbox-interactive-video-9e6cbe88157da819c666ccddf33549a6.png";